<template>
    <!-- Filter leads -->
    <CContainer fluid>
        <CRow class="justify-cotent-center m-0">
            <CCol md="8" sm="12">
                <SelectAsync
                    :label="$t('database')+':'"  
                    :placeholder="$t('--_select_an_option_--')"
                    :name="'db_id'"
                    :horizontal="{
                        label:'col-sm-3',
                        input:'col-sm-9',
                    }"

                    :optionsValue="'id'"
                    :optionsLabel="'name'"
                    :endpoint="'db'"

                    :isValid="checkFieldValid('database')"
                    :value.sync="$v.database.$model"
                />
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>

import SelectAsync from "£lement/SelectAsync";
import { cilFilter } from '@coreui/icons';
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
    name: "FilterLeadsComponent",
    icons:{cilFilter},
    components:{
        SelectAsync,
    },
    mixins: [ validationMixin ],
    data(){
        return { 
            database:null
        }
    },
    validations: {
        database:{
            required
        }
    },
    computed:{
        ...mapGetters({
            storeDatabase:"filter/database"
        }),
    },
    watch:{
        database(newValue){
            this.$store.dispatch('filter/saveDatabase', {
                database:newValue
            });
        }
    },
    methods:{
        checkFieldValid(fieldName){
            const field = this.$v[fieldName];
            if (!field.$dirty) {
                return null
            } 
            return !(field.$invalid || field.$model === '')
        },
        emitEventUpdateData(data){
            this.$emit('updateData',data);
        },
        initFilters(){
            if(this.storeDatabase){
                this.database = this.storeDatabase;
            }
        }
    },
    mounted(){
        this.initFilters();
            
    }
    
}
</script>

<style lang="scss" scoped>
    input{
        height: auto !important;
    }

</style>